import React from 'react';
import styled from 'styled-components';

import { ModalContainer, ModalExitIcon } from 'components/core';
import { HorizontalDivider } from 'components/core/divider';
import { formatCurrency } from 'shared/helpers/utils';
import type { PosOrderFieldsFragment } from 'src/gql/graphql';

import { InstoreReceiptHeader } from './instore-receipt-header';
import { InstoreReceiptItemMobile } from './instore-receipt-item-mobile';
import { InstoreReceiptDetails } from './instore-receipt-details';
import { InstoreReceiptTotals } from './instore-receipt-totals';

type InstoreReceiptMobileProps = {
  posOrder: PosOrderFieldsFragment;
  onClose: () => void;
};

export function InstoreReceiptMobile({ posOrder, onClose }: InstoreReceiptMobileProps): JSX.Element {
  const items = posOrder.items ?? [];

  return (
    <Container data-testid='instore-order-receipt-modal-mobile'>
      <ExitButton onClick={onClose} />
      <InstoreReceiptHeader locationDetails={posOrder.locationDetails} />
      <ItemsContainer role='list'>
        {items.map((item, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <ItemContainer key={`${item.productName}-${index}`}>
            <InstoreReceiptItemMobile
              productName={item.productName}
              brandName={item.brandName}
              option={item.option}
              quantity={item.quantity}
              formattedPrice={formatCurrency(item.price * item.quantity)}
            />
            <Divider />
          </ItemContainer>
        ))}
      </ItemsContainer>
      <InstoreReceiptDetails posOrder={posOrder} />
      <TotalsContainer>
        <InstoreReceiptTotals posOrder={posOrder} />
      </TotalsContainer>
    </Container>
  );
}

const Container = styled(ModalContainer)`
  overflow: auto;
  max-width: 85%;
  display: flex;
  flex-direction: column;
  border-radius: 14px;
  padding: 24px 5% 0;
  margin-bottom: 40px;
  top: 20px;
  transform: none;
`;

const ExitButton = styled(ModalExitIcon)`
  right: 16px;
  @media (max-width: 350px) {
    right: 10px;
  }
`;

const ItemsContainer = styled.ul`
  list-style: none;
  margin: 0;
  padding: 24px 0;
`;

const ItemContainer = styled.li`
  display: block;
  width: 100%;
`;

const Divider = styled(HorizontalDivider)``;

const TotalsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  margin-bottom: 40px;
`;
